<div class="appCntnr">
  <app-list></app-list>
</div>
